import v2Axios from "../v2Axios";
import { CONFIG } from "../../config";
export const getSubCoursesWithSubCourseId = async (subCoursesId) => {
	try {
		const response = await v2Axios.get(
			`${CONFIG.COURSEURL}/api/v2/subcourses/sub/all/` + subCoursesId
		);
		return response.data;
	} catch (error) {
		// returning blank array after getting server and internet error
		return [];
	}
};
